export default __webpack_public_path__ + "images/b4a2c827f30f313141217e4d87c907e2-4_mobile_659x494.webp";